<template>
    <user-form v-if="user" :user="user"></user-form>
</template>

<script>
    import axios from 'axios';
    import UserForm from '../components/UserForm'
    export default {
        name: 'users-edit',
        data () {
            return {
                user: false
            }
        },
        components: {
            UserForm
        },
        mounted() {
            axios
                .get('/api/users/' + this.$route.params.id)
                .then((response) => {
                    this.user = response.data.data
                })
        }
    }
</script>
